export default __webpack_public_path__ + "static/mentors-5f916868efaac57e5035a802a9816c81.png";